import { Link } from 'react-router-dom';
import { useState } from 'react';

const servicesLinks = [
  { label: 'Kitchen Remodeling', path: '/services/kitchen-remodeling' },
  { label: 'Bathroom Remodeling', path: '/services/bathroom-remodeling' },
  { label: 'Plumbing Services', path: '/services/plumbing' },
  { label: 'General Contracting', path: '/services/general-contracting' },
  { label: 'Cleaning Services', path: '/cleaning-services' },
];

const quickLinks = [
  { label: 'About Us', path: '/about' },
  { label: 'Projects', path: '/projects' },
  { label: 'Reviews', path: '/reviews' },
  { label: 'Contact', path: '/contact' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subscribeMsg, setSubscribeMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
  e.preventDefault();
  if (!email.trim()) return;
  setSubscribeStatus('loading');

  try {
    const res = await fetch('https://formspree.io/f/xoealonn', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        email: email,
        _subject: 'New Newsletter Subscription - Rafael M&C',
      }),
    });

    if (res.ok) {
      setSubscribeStatus('success');
      setSubscribeMsg('Thank you for subscribing!');
      setEmail('');
    } else {
      setSubscribeStatus('error');
      setSubscribeMsg('Something went wrong. Please try again.');
    }
  } catch {
    setSubscribeStatus('error');
    setSubscribeMsg('Network error. Please try again.');
  }
};

  return (
    <footer className="bg-accent-950 text-background-50">
      <div className="px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img
                src="/images/LOGO-RAFAEL.webp"
                alt="Rafael M&C Constructions LLC"
                className="h-10 w-auto object-contain"
              />
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed mb-5">
              Family-owned general contractor with over 10 years of experience. Proudly serving Virginia, Maryland, and Washington D.C.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://www.facebook.com/profile.php?id=100092352304328" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-900/50 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" aria-label="Facebook">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="https://www.instagram.com/rafaelmcontructions/" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-900/50 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-900/50 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" aria-label="Google Business Profile">
                <i className="ri-google-fill"></i>
              </a>
              <a href="https://www.yelp.com/biz/rafael-m-and-c-constructions-sterling" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-900/50 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" aria-label="Yelp">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
  <path d="M4.85 3.258c.216-.194.505-.284.79-.24l7.28 1.048c.505.075.85.545.775 1.05a.918.918 0 0 1-.79.79l-5.36 1.02c-.55.104-1.08-.26-1.185-.81a.972.972 0 0 1 .036-.51L4.32 4.09a.937.937 0 0 1 .53-.832zm5.06 8.12l-4.87 3.51a.972.972 0 0 1-1.36-.24.937.937 0 0 1-.036-1.02l2.79-4.53a.94.94 0 0 1 1.29-.33l1.9 1.14c.45.27.596.85.286 1.29zm2.44 3.55l1.02 5.36c.104.55-.26 1.08-.81 1.185a.972.972 0 0 1-1.02-.4l-3.15-4.44a.94.94 0 0 1 .24-1.31l1.9-1.14c.45-.27 1.03-.13 1.29.33.06.11.09.24.09.375zm5.35-3.4l4.87 2.05c.51.216.75.81.535 1.32a.937.937 0 0 1-.87.575l-5.36-.24a.94.94 0 0 1-.9-1.05l.24-1.9c.06-.51.51-.87 1.02-.81.155.02.31.075.465.155z"/>
</svg>
              </a>
            </div>
          </div>

          <div>
            <h5 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-50 mb-5">Services</h5>
            <ul className="space-y-3">
              {servicesLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h5 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-50 mb-5">Quick Links</h5>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h5 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-50 mb-5">Stay Updated</h5>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              Get tips and special offers straight to your inbox.
            </p>
            <form onSubmit={handleSubscribe} data-readdy-form="" className="space-y-3">
              <div className="relative">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  required
                  className="w-full bg-accent-900/40 border border-accent-800/50 rounded-lg px-4 py-2.5 text-sm text-background-50 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 transition-colors"
                />
                <button
                  type="submit"
                  disabled={subscribeStatus === 'loading'}
                  aria-label="Subscribe to newsletter"
                  className="absolute right-1.5 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors disabled:opacity-60 cursor-pointer"
                >
                  {subscribeStatus === 'loading' ? (
                    <i className="ri-loader-4-line animate-spin text-sm"></i>
                  ) : (
                    <i className="ri-arrow-right-line text-sm"></i>
                  )}
                </button>
              </div>
              <div className="antispam-field">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              {subscribeStatus !== 'idle' && (
                <p className={`text-xs ${subscribeStatus === 'success' ? 'text-accent-300' : 'text-red-400'}`}>
                  {subscribeMsg}
                </p>
              )}
            </form>
            <div className="mt-5 space-y-2">
              <a href="tel:+15713652634" className="flex items-center gap-2 text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-phone-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                (571) 365-2634
              </a>
              <a href="mailto:rafaelm.construction@gmail.com" className="flex items-center gap-2 text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-mail-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                rafaelm.construction@gmail.com
              </a>
              <p className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-map-pin-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                Sterling, Virginia 20164
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-accent-900/60">
        <div className="px-4 md:px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-200">
  &copy; {new Date().getFullYear()} Rafael M&C Constructions LLC. All rights reserved.
</p>
          <p className="text-xs text-foreground-200">
  Fully Licensed &amp; Insured | Serving VA, MD &amp; DC
</p>
        </div>
      </div>

      <div className="px-4 md:px-6 lg:px-10 pb-8 overflow-hidden">
        <p aria-hidden="true" className="font-heading text-[clamp(3rem,12vw,10rem)] font-bold text-accent-900/30 leading-none select-none whitespace-nowrap">
  RAFAEL M&C
</p>
      </div>
    </footer>
  );
}